import React from 'react';

export const EmailToRss = () => (
    <div className="mb-6">
        <iframe src="https://ozkaas.com/" allow="clipboard-read; clipboard-write" height="600px" style={{ border: 0 }} />;
    </div>
);
